import { cloneDeep } from "lodash";
import { getState } from "../state/store";
import { selectSystemNotifications } from "../state/selectors";
import { systemNotificationOptions } from "../consts";

const formatSystemNotifications = (systemNotifications = []) => {
  const formattedSystemNotifications = systemNotifications.map((notification) => {
    const createdBy = {
      createdTs: notification?.created_by?.created_ts,
      sender: notification?.created_by?.email,
      ...notification?.created_by
    };

    return {
      notificationName: notification?.notification_name,
      notificationType: notification?.notification_type,
      isSystemNotification: notification?.notification_type === "SYSTEM",
      createdBy: createdBy,
      ...notification
    };
  });

  return formattedSystemNotifications;
};

const prepareNotificationData = (notification, isSystemNotification) => {
  const updatedNotification = cloneDeep(notification);
  delete updatedNotification.image;

  if (isSystemNotification) {
    updatedNotification.notificationName = updatedNotification.notificationName?.id;
    updatedNotification.notificationType = "SYSTEM";

    const localizationData = updatedNotification.localizations;
    const localizationKeys = updatedNotification.localizations.map(
      (localization) => localization?.language
    );

    updatedNotification.localizations = {};

    localizationKeys.forEach((key) => {
      const data = localizationData?.find((el) => el.language === key) ?? {};
      delete data.language;

      updatedNotification.localizations[key] = data;
    });
  }

  return updatedNotification;
};

const getAvailableSystemNotificationOptions = () => {
  const systemNotifications = selectSystemNotifications()(getState()) ?? [];

  const usedSystemNotificationNames = systemNotifications?.map(
    (notification) => notification.notificationName
  );

  const availableSystemNotificationOptions = systemNotificationOptions.filter(
    (opt) => !usedSystemNotificationNames.includes(opt.id)
  );

  return availableSystemNotificationOptions;
};

const notificationUtils = {
  formatSystemNotifications,
  prepareNotificationData,
  getAvailableSystemNotificationOptions
};

export default notificationUtils;
